import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { VolumeX, Volume2 } from "lucide-react";

const PropertyVideo = () => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !muted;
    setMuted(!muted);
  };

  return (
    <section className="relative w-full bg-black overflow-hidden">
      <div className="relative w-full aspect-[16/9] sm:aspect-[21/9]">
        {/* 🎥 Video */}
        <video
          ref={videoRef}
          src="/videos/grand-cinemaz-property.mp4"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/images/grand-cinemaz-thumb.jpg"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* 🌑 Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent" />

        {/* 🔊 Mute / Unmute Button */}
        <button
          onClick={toggleMute}
          aria-label={muted ? "Unmute video" : "Mute video"}
          className="absolute top-3 right-3 sm:top-6 sm:right-6 z-20
                     rounded-full bg-black/60 backdrop-blur
                     p-2.5 sm:p-3
                     text-white hover:bg-black/80 transition"
        >
          {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
        </button>

        {/* 🏛️ Content */}
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="absolute inset-x-0 bottom-4 sm:bottom-10 px-4 sm:px-8"
        >
          <div className="mx-auto max-w-7xl text-center">
            <h2 className="text-white font-extrabold tracking-wide text-xl sm:text-3xl md:text-5xl">
              Experience Grand Cinemaz
            </h2>

            <p className="mt-2 sm:mt-4 text-gray-200/90 text-xs sm:text-sm md:text-lg max-w-2xl mx-auto">
              Luxury seating • Immersive sound • Premium ambience • World-class
              screens
            </p>

            <div className="mt-3 sm:mt-6 flex items-center justify-center gap-3">
              <a
                href="/movies"
                className="rounded-full bg-red-600 hover:bg-red-700 text-white
                           px-5 py-2.5 sm:px-7 sm:py-3
                           text-sm sm:text-base font-semibold transition"
              >
                Book Tickets
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="h-6 sm:h-10 bg-black" />
    </section>
  );
};

export default PropertyVideo;
